import { useMemo } from 'react';
import { Icon, RoundElement } from 'ui';

type P = {
  channelAppearance: { featured?: boolean; visible?: boolean };
};

export const useGetChannelAppearanceInformation = ({ channelAppearance }: P) =>
  useMemo(() => {
    if (channelAppearance.featured) {
      return {
        description: 'Object will be visible as featured in Channels',
        icon: (
          <RoundElement size="extra-small">
            <Icon color="text" icon="star-line" />
          </RoundElement>
        ),
        name: 'Featured',
      };
    }

    if (channelAppearance.visible) {
      return {
        description: 'Object will be visible in Channels',
        icon: (
          <RoundElement size="extra-small">
            <Icon color="text" icon="eye-2-line" />
          </RoundElement>
        ),
        name: 'Visible',
      };
    }

    return undefined;
  }, [channelAppearance]);
